import React from "react";
import './index.css'

interface attractionsPageProps{
    className?:string
}

export const AttractionPage:React.FC<attractionsPageProps> = ({className})=>{
    return(
        <div className={`${className}`}>
            <h3>Attraction Page </h3>
        </div>
    )
}